var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block",
    staticStyle: {
      width: "80%"
    }
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Unit"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.data.unit_name,
      callback: function ($$v) {
        _vm.$set(_vm.data, "unit_name", $$v);
      },
      expression: "data.unit_name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Product"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.data.product_name,
      callback: function ($$v) {
        _vm.$set(_vm.data, "product_name", $$v);
      },
      expression: "data.product_name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Variant"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.data.productsVariation_name,
      callback: function ($$v) {
        _vm.$set(_vm.data, "productsVariation_name", $$v);
      },
      expression: "data.productsVariation_name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Quantity To Remove",
      prop: "quantity"
    }
  }, [_c("el-input-number", {
    attrs: {
      size: "mini",
      min: 1
    },
    model: {
      value: _vm.formData.quantity,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "quantity", $$v);
      },
      expression: "formData.quantity"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Comments",
      prop: "comments"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autocomplete: "off",
      rows: 5,
      placeholder: "reason for removing quantity.."
    },
    model: {
      value: _vm.formData.comments,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "comments", $$v);
      },
      expression: "formData.comments"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };